import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { PaletteDb } from '../redux/paletteDbSlice';

const useOnePaletteValue = (paletteId: string | undefined): PaletteDb | undefined => {
  const paletteDb = useSelector((state: RootState) => state.paletteDb);
  const palette = paletteId ? paletteDb.palettes[paletteId] : undefined;

  return palette;
}

export default useOnePaletteValue;
